import { ISimpleType, types } from 'mobx-state-tree'

const InsuranceCurrency = types.enumeration(['EUR', 'USD'])
type TInsuranceCurrency = typeof InsuranceCurrency.Type

export const QuoteRequestInsuranceMst = types
  .model('QuoteRequestInsurance', {
    id: types.frozen as ISimpleType<'A' | 'B' | 'C'>,
    faqKey: types.frozen as ISimpleType<'a' | 'b' | 'c'>,
    checked: false,
    value: types.maybe(types.number),
    currency: types.optional(InsuranceCurrency, 'EUR'),
  })
  .actions((self) => ({
    setChecked(checked: boolean) {
      self.checked = checked
    },
    setValue(value: string | number) {
      if (typeof value === 'string' && !value) {
        self.value = null
      } else {
        self.value = Number(value)
      }
    },
    setCurrency(currency: TInsuranceCurrency) {
      self.currency = currency
    },
  }))
